import React from 'react'
import PropTypes from 'prop-types'
import { VehiculeTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const VehicleList = ({
  fetchData,
  success,
  pageLimitChanged,
  pageChanged,
  onCloseReset,
  isLoadingfetchVehicules,
  vehiculesList,
  vehiculesListCount,
  searchData,
  errorMessage,
  errorMessageConfig,
  removeError,
  isErrorFetch,
  isSuccessRefresh,
  resetSuccessAction,
  removeErrorConfig,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={true}
      tableHead={VehiculeTableHead}
      //Commonfields
      globalID={'Vehicule'}
      searchPlaceholder={'Rechercher par Véhicule'}
      title={'Gestion véhicules'}
      fetchData={fetchData}
      loadingData={isLoadingfetchVehicules}
      dataList={vehiculesList}
      countData={vehiculesListCount}
      errorMessage={errorMessage || errorMessageConfig}
      removeError={removeError}
      removeErrorConfig={removeErrorConfig}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isVehicle={true}
    />
  )
}
VehicleList.propTypes = {
  fetchData: PropTypes.func,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  onCloseReset: PropTypes.func,
  searchData: PropTypes.func,
  success: PropTypes.bool,
  vehiculesListCount: PropTypes.number,
  errorMessage: PropTypes.string,
  errorMessageConfig: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
  isLoadingfetchVehicules: PropTypes.bool,
  vehiculesList: PropTypes.array,
  removeErrorConfig: PropTypes.func,
}
export default VehicleList
